import React from "react";
import { ArrowLeft, X } from "lucide-react";

const CloudUploadIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
    <path d="M12 12v9" />
    <path d="m9 15 3-3 3 3" />
  </svg>
);

interface ImportModalHeaderProps {
  onClose: () => void;
  onBack?: () => void;
}

export const ImportModalHeader: React.FC<ImportModalHeaderProps> = ({ onClose, onBack }) => {
  return (
    <div className="p-6 border-b border-slate-100 flex flex-row items-center gap-4 text-left relative shrink-0">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="w-10 h-10 rounded-full border border-slate-200 hover:bg-slate-50 flex items-center justify-center text-slate-500 hover:text-slate-700 transition-colors focus:outline-none shrink-0"
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
      )}
      <div className="w-14 h-14 rounded-full bg-[#A655F8] flex items-center justify-center text-white shrink-0 shadow-[0_4px_20px_rgba(166,85,248,0.25)]">
        <CloudUploadIcon />
      </div>
      <div className="flex-grow">
        <h2 className="text-[30px] font-bold text-slate-900 leading-tight">
          Import Influencers from CSV
        </h2>
        <p className="text-[16px] text-slate-500 font-normal mt-1 leading-normal">
          Upload a CSV file with Instagram handles to add multiple influencers at once.
        </p>
      </div>

      {/* Custom Close Button */}
      <button
        type="button"
        onClick={onClose}
        className="absolute right-6 top-6 w-8 h-8 rounded-full border border-slate-200 hover:bg-slate-50 flex items-center justify-center text-slate-400 hover:text-slate-600 transition-colors focus:outline-none"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
